import { render, staticRenderFns } from "./Page_PetContest.vue?vue&type=template&id=67078a92&scoped=true&"
import script from "./Page_PetContest.vue?vue&type=script&lang=js&"
export * from "./Page_PetContest.vue?vue&type=script&lang=js&"
import style0 from "./Page_PetContest.vue?vue&type=style&index=0&id=67078a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67078a92",
  null
  
)

export default component.exports